import {PERSONAL_ROOM_USER_LIMIT} from '../constants/mybobtv';

export function mapNeoRoomToRoomItem(neoRoom) {
    return {
        _type: 'neo',
        roomid: neoRoom.id,
        name: neoRoom.name,
        is_primary: neoRoom.is_primary,
        is_secondary: neoRoom.is_secondary,
        description: neoRoom.description,
        userLimit: neoRoom.userLimit,
        userCount: neoRoom.globalUserCount,
        users: neoRoom.users,
        url: neoRoom.chatScriptUrl,
        url_lc: neoRoom.chatScriptUrl_lc
    }
}

export function mapNeoPersonalRoomToRoomItem(neoPersonalRoom) {
    return {
        _type: 'neo',
        showroom_price: neoPersonalRoom.showroom_price ? neoPersonalRoom.showroom_price : 0,
        roomid: neoPersonalRoom.roomid,
        name: neoPersonalRoom.name,
        is_primary: false,
        is_secondary: false,
        description: '',
        userLimit: PERSONAL_ROOM_USER_LIMIT,
        userCount: neoPersonalRoom.userCount,
        users: neoPersonalRoom.users,
        url: neoPersonalRoom.chatScriptUrl,
        personal: true,
        creator: neoPersonalRoom.creator,
        active: true
    }
}


// WEBPACK FOOTER //
// ./src/utils/rooms.js